/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/373-ltr': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a4 4 0 000 8v8h2V2h2v14h2V2h2V0H8zM0 11l4-4-4-4z"/>'
  }
})
